<template lang="pug">
  .acesso-negado
    .simbolo-de-negado
      svg(width="279" height="279" viewBox="0 0 279 279" fill="none")
        path(
          d="M186.981 279H91.709C85.8223 279 78.5413 276.057 74.5136 271.874L7.12603 204.486C2.94335 200.304 0 193.023 0 187.291V91.864C0 85.9772 2.94335 78.6963 7.12603 74.5136L74.5136 7.12604C78.6962 2.94337 85.9772 0 91.864 0H187.136C193.023 0 200.304 2.94337 204.486 7.12604L271.874 74.5136C276.057 78.6963 279 85.9772 279 91.864V187.136C279 193.023 276.057 200.304 271.874 204.331L204.486 271.719C199.994 276.057 192.868 279 186.981 279ZM91.709 15.6463C90.005 15.6463 86.5969 17.0405 85.3576 18.2798L17.9701 85.6674C16.7308 86.9067 15.3364 90.3148 15.3364 92.0189V187.291C15.3364 188.995 16.7308 192.403 17.9701 193.642L85.3576 261.03C86.5969 262.269 89.8501 263.664 91.709 263.664H186.981C188.685 263.664 192.093 262.269 193.333 261.03L260.72 193.642C261.959 192.403 263.354 188.995 263.354 187.291V91.864C263.354 90.1599 261.959 86.7518 260.72 85.5125L193.333 18.2798C192.093 17.0405 188.84 15.6463 186.981 15.6463H91.709Z"
          fill="#FF6854"
        )
        path(
          d="M185.161 86.6865C179.231 86.6865 174.37 91.4994 174.37 97.3711V138.569C174.37 139.243 173.786 139.821 173.106 139.821C172.425 139.821 171.842 139.243 171.842 138.569V76.4831C171.842 70.6114 166.981 65.7985 161.05 65.7985C155.12 65.7985 150.259 70.6114 150.259 76.4831V132.409C150.259 133.083 149.676 133.66 148.995 133.66C148.315 133.66 147.731 133.083 147.731 132.409V67.0498C147.731 61.1781 142.87 56.3652 136.94 56.3652C131.009 56.3652 126.148 61.1781 126.148 67.0498V126.73C126.148 127.404 125.565 127.981 124.884 127.981C124.204 127.981 123.62 127.404 123.62 126.73V80.2372C123.62 74.3655 118.759 69.5526 112.829 69.5526C106.899 69.5526 102.037 74.3655 102.037 80.2372V162.634C102.037 163.115 101.746 163.597 101.26 163.789C100.774 163.982 100.287 163.885 99.8985 163.5L84.0518 147.81C81.6212 145.404 78.5101 144.152 75.1073 144.152C71.7046 144.152 68.4962 145.5 66.1629 147.81C63.7324 150.217 62.4688 153.297 62.4688 156.666C62.4688 160.035 63.8296 163.211 66.1629 165.522L108.746 207.683C118.37 217.212 131.106 222.41 144.62 222.41C158.134 222.41 170.87 217.212 180.495 207.683C190.119 198.153 195.369 185.543 195.369 172.164V97.2749C195.953 91.4994 191.092 86.6865 185.161 86.6865Z"
          fill="#FF6854"
        )
    .coluna-de-texto
      .status 403
      .subtitulo acesso negado
      .texto o IP {{ipDoUsuarioFormatado}} não tem autorização para acessar registro.pontotel.com.br
      .texto por favor conecte-se a uma rede autorizada e tente novamente
      .link(@click="redirecionarParaTelaInicial") voltar para a tela inicial
      .imagem-pontotel
        img(src="../../../static/images/logo-colorido.png")
</template>

<script>
export default {
  name: 'AcessoNegado',
  async created () {
    const resultado = await this.$API.consultaIp.get()
    if (resultado.status === 200) {
      this.ipDoUsuario = resultado.body.ipDoUsuario
    } else {
      console.log('não foi possível pegar ip')
    }
  },
  data () {
    return {
      ipDoUsuario: null
    }
  },
  computed: {
    ipDoUsuarioFormatado () {
      if (!this.ipDoUsuario) return ''
      return this.ipDoUsuario
    }
  },
  methods: {
    redirecionarParaTelaInicial () {
      this.$router.push('/register/code')
    }
  }
}
</script>

<style scoped>
.acesso-negado {
  background-color: white;
  height: 100vh;
  display: grid;
  grid-template-columns: max-content 477px;
  column-gap: 116px;
  align-items: center;
  justify-content: center;
}
.status {
  font-family: Rubik;
  font-style: normal;
  font-weight: 500;
  font-size: 65px;
  line-height: 77px;
  color: #2C3E50;
}
.subtitulo {
  padding-bottom: 34px;

  font-family: Rubik;
  font-style: normal;
  font-weight: normal;
  font-size: 40px;
  line-height: 47px;
  color: #2C3E50;
}
.texto {
  padding-bottom: 10px;

  font-family: Rubik;
  font-style: normal;
  font-weight: 300;
  font-size: 24px;
  line-height: 28px;
  color: #2C3E50;
}
.link {
  padding-bottom: 25px;

  font-family: Rubik;
  font-style: normal;
  font-weight: 300;
  font-size: 24px;
  line-height: 28px;
  text-decoration-line: underline;
  cursor: pointer;

  color: #00A2B5;
}
</style>
